module.exports = __webpack_public_path__ + "img/hover_Icon_Estudiante_Transicion.29b4e6d6.svg";